'use strict';

module.exports = 'ck-v4-';
